/* src/app/sign-in/sign-in.component.scss */
h1 {
  padding: 48px 0;
}
h3 {
  margin-bottom: 0.35em;
}
.wrapper {
  width: 400px;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.7);
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px #fff solid;
  border-radius: 20px;
}
.sign {
  background: url("./media/sign-bg.jpg") center;
  background-size: cover;
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
}
/*# sourceMappingURL=sign-in.component.css.map */
